export default "__VITE_ASSET__CfqMLMLb__"